import { axios } from '@Root/API'

export const create = (engagementId, payload) => {
	return axios.post(`student-engagement/${engagementId}/collaborative-provision`, payload)
}
